import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { Roles } from '../enums/role.enum';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root', })
export class AccessControlService {
  permissions!: string[];
  currentRole:Roles | null | undefined = null;
  constructor(private authService: AuthService) {
    this.authService.getUserPermissionState().subscribe(data => {
      this.permissions = data;
    });

    this.authService.getUserState().subscribe(user=> {
      this.currentRole = user?.roleCode;
    });
  }

  isUserPermitted(inPermission: string[]): Observable<boolean> {
    return this.authService.getUserPermissionState()
      .pipe(
        map(permissions => permissions.findIndex(permission => permission && inPermission ? inPermission.includes(permission.trim()) : false) > -1)
      );
  }

  applyPermissions(list: any[]): any[] {
    if (!list) {
      return list;
    }
    return list.filter(i => {
      if (Array.isArray(i)) {
        return this.applyPermissions(i);
      } else {
        return !i.permission ||
          this.permissions.findIndex(permission => permission ?  i.permission.includes(permission.trim()) : false) > -1;
      }
    });
  }

  applyRoleRestriction(list: any[]): any[] {
    if (!list) {
      return list;
    }
    return list.filter(i => {
      if (Array.isArray(i)) {
        return this.applyRoleRestriction(i);
      } else {
        return !(i.restrictedRoles && i.restrictedRoles.includes(this.currentRole))
          //i.restrictedRoles.findIndex(roles => roles ?  i.permission.includes(permission.trim()) : false) > -1;
      }
    });
  }

  applyMenuPermissions(list: any[]): any[] {
    if (!list) {
      return list;
    }
    return list.filter(i => {
      if (i && i.submenu && Array.isArray(i.submenu)) {
        i.submenu = this.applyPermissions(i.submenu);
      }
      return !i.permission ||
          this.permissions.findIndex(permission => permission ? i.permission.includes(permission.trim()) : false) > -1;

    });
  }

  filterMenuRoleRestriction(list: any[]): any[] {
    if (!list) {
      return list;
    }
    return list.filter(i => {
      if (i && i.submenu && Array.isArray(i.submenu)) {
        i.submenu = this.applyRoleRestriction(i.submenu);
      }
      return !(i.restrictedRoles && i.restrictedRoles.includes(this.currentRole));
    });
  }



}
